import _ from 'lodash';

export interface TableSortBy {
  id: string;
  desc: boolean;
}

export interface TableFilter {
  id: string;
  value: string;
}

export const buildOrderByString = (sortBy: TableSortBy[]): string =>
  sortBy.length > 0 ? `${sortBy[0].id} ${sortBy[0].desc ? 'desc' : 'asc'}` : '';

export const buildNestedFilters = (filters: TableFilter[]): Record<string, any> =>
  filters.reduce((acc, filter) => {
    if (filter.value !== undefined && filter.value !== null && filter.value !== '') {
      _.set(acc, filter.id, filter.value);
    }
    return acc;
  }, {} as Record<string, any>);
